<template>
  <div class="bookingComp">
    <sidebar_user :setorders="orders" />
    <section class="home-section">
      <div class="space"></div>
      <b-container>
        <div
          id="cart"
          class="cart"
          :data-totalitems="items.length"
          v-b-modal.modal-1
          v-if="!user && !staff && code !== ''"
        >
          <i class="fas fa-shopping-cart"></i>
        </div>
        <!-- ============================================== MoDal ======================================-->

        <b-modal id="modal-1" title="รายการหนังสือ" size="lg">
          <div class="modal-body">
            <div class="grey-bg container-fluid">
              <section id="stats-subtitle">
                <div class="row">
                  <div
                    class="col-xl-12 col-md-12"
                    v-for="(item, index) in items"
                    :key="index"
                    transition="fade"
                  >
                    <div class="card overflow-hidden item-modal shadow mb-4">
                      <div class="card-content">
                        <div class="card-body cleartfix">
                          <div class="media align-items-stretch">
                            <div class="align-self-center">
                              <img
                                :src="item.img_url"
                                alt=""
                                class="modal-img icon-pencil primary font-large-2 mr-2"
                              />
                              <!-- <i
                                  class="icon-pencil primary font-large-2 mr-2"
                                ></i> -->
                            </div>

                            <div class="media-body txt-modal">
                              <h6>
                                ชื่อหนังสือ |
                                {{ item.book_title.slice(0, 40) }}...
                              </h6>
                              <h6>
                                ชื่อผู้แต่ง|
                                {{ item.book_author.slice(0, 30) }}
                              </h6>
                              <!-- <span>Monthly blog posts</span> -->
                            </div>
                            <div class="align-self">
                              <div>
                                <span class="badge badge-purple"
                                  >{{ item.qty_booking }} เล่ม
                                </span>
                              </div>
                              <br />
                              <i
                                class="fas fa-trash-alt fa-lg"
                                @click="removeFromCart(item)"
                              ></i>
                              <!-- <h1>18,000</h1> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>

          <template #modal-footer="{ cancel, Login }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button
              size="sm"
              class="btn btn-purple"
              @click="sendItem(items)"
              v-if="items.length !== 0 && !user"
            >
              จองหนังสือ
            </b-button>
            <b-button
              size="sm"
              class="btn btn-secondary"
              @click="cancel()"
              v-if="!user"
            >
              ยกเลิก
            </b-button>
            <!-- Button with custom close trigger value -->
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="Login()"
              v-if="user"
            >
              จองหนังสือ
            </b-button>
          </template>
        </b-modal>
        <!-- ============================================== END MoDal======================================== -->
        <!-- ====================================== SEARCH ======================================== -->

        <div class="row">
          <div class="col-xl-2 col-lg-2 col-md-2 col-xs-0"></div>
          <div class="col-xl-8 col-lg-8 col-md-8 col-xs-12">
            <form action="" @submit.prevent="Dosearch">
              <div class="search">
                <input
                  id="myInput"
                  type="text"
                  class="search__input"
                  placeholder="ค้นหาหนังสือ"
                  style="border-radius: 30px"
                  pull-right
                  v-model="inputsearch"
                />

                <div class="search__icon">
                  <i class="fa-solid fa-search"></i>
                  <!-- <ion-icon name="search"></ion-icon> -->
                </div>
              </div>
            </form>
          </div>
          <div class="col-xl-2 col-lg-2 col-md-2 col-xs-0"></div>
        </div>

        <!-- END -->
        <div class="space"></div>
        <!-- ================================== No item ========================================== -->
        <div class="row" v-if="datas.length === 0">
          <div class="col-xl-2 col-lg-2 col-md-2 col-xs-0"></div>
          <div class="col-xl-8 col-lg-8 col-md-8 col-xs-12">
            <br />
            <div class="chip">
              <div class="chip__icon">
                <i
                  class="fa-regular fa-face-sad-tear"
                  style="color: Tomato"
                ></i>
              </div>
              <p>ขออภัย ไม่มีรายการที่ค้นหา</p>
              <div class="chip__close">
                <!-- <ion-icon name="close"></ion-icon> -->
              </div>
            </div>
          </div>
          <div class="col-xl-2 col-lg-2 col-md-2 col-xs-0"></div>
        </div>
        <!-- END No item -->
        <!-- ===============================Detail Book Item ==================================== -->
        <main class="pt-1">
          <div class="row" v-if="datas.length !== 0">
            <div
              class="col-md-6 col-sm-6 col-xs-6 col-sm-offset-6 col-xs-offset-6"
              v-for="(item, index) in datas"
              :key="index"
            >
              <div
                class="card flex-md-row mb-4 border-0 shadow h-md-250 card-service"
                id="crad-media-size"
                style="border-radius: 30px"
              >
                <img
                  class="card-img-left flex-auto d-md-block zoom"
                  :src="item.img_url"
                  alt="Card image cap"
                  id="cardimg"
                  style="border-radius: 40px"
                />
                <div
                  class="card-body d-flex flex-column align-items-start card-content-add"
                >
                  <!-- ******* -->

                  <!-- ******* -->

                  <h6 class="card-title" v-if="!readMore[item.b4web_id]">
                    <i class="fas fa-book"></i>
                    ชื่อหนังสือ : {{ item.book_title.slice(0, 32) }}
                    <a
                      class=""
                      v-if="
                        !readMore[item.b4web_id] && item.book_title.length > 32
                      "
                      @click="showMore(item.b4web_id)"
                      ><strong class="text-danger">[...]</strong></a
                    >
                  </h6>
                  <h6 class="card-title" v-if="readMore[item.b4web_id]">
                    <i class="fas fa-book"></i>
                    ชื่อหนังสือ : {{ item.book_title }}
                    <a
                      class=""
                      v-if="readMore[item.b4web_id]"
                      @click="showLess(item.b4web_id)"
                    >
                      <strong class="text-danger"> [ย่อ]</strong></a
                    >
                  </h6>
                  <p class="card-text" v-if="item.book_author == ''">
                    <i class="fas fa-user-edit"></i> ไม่ทราบชื่อผู้แต่ง
                  </p>
                  <p class="card-text" v-if="item.book_author !== ''">
                    <i class="fas fa-user-edit"></i> ชื่อผู้แต่ง :
                    {{ item.book_author }}
                    <br />
                  </p>
                  <p class="card-text">
                    <i class="fas fa-layer-group"></i> หมวดหมู่ :
                    {{ item.book_classification }}
                  </p>
                  <p class="card-text">
                    <i class="fas fa-calendar-alt"></i> ปีที่พิมพ์ :
                    {{ item.book_print }}
                  </p>
                  <p class="card-text">
                    <i class="fas fa-map-marker-alt"></i> ที่อยู่หนังสือ :
                    {{ item.location }}
                  </p>

                  <p class="card-text" style="font-size: 13px">
                    <i class="fa-solid fa-caret-right"></i> {{ item.place }} :
                    {{ item.publisher }}
                  </p>

                  <div class="spaceCart" v-if="!staff"></div>
                  <div class="card-content">
                    <div class="page-wrapper" v-if="!staff">
                      <button
                        id="addtocart"
                        class="btn btn-purple badge-pill addtocart_"
                        data-position="bottom"
                        data-delay="50"
                        data-tooltip="Add to favorites"
                        v-show="item.qty_available !== 0"
                        v-if="!disable[(item, item.b4web_id)] && !user"
                        @click="addToCart(item, item.b4web_id)"
                      >
                        จอง
                        <span class="cart-item"></span>
                      </button>
                    </div>

                    <div class="page-wrapper" v-if="user || code === ''">
                      <button
                        class="btn btn-purple badge-pill addtocart_"
                        data-position="bottom"
                        data-delay="50"
                        data-tooltip="Add to favorites"
                        @click="Login()"
                      >
                        จอง
                        <span class="cart-item"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

        <!-- END Deatil book-->
      </b-container>
    </section>
  </div>
</template>

<script>
import sidebar_user from "../layouts/sidebar_user.vue";
import axios from "axios";
import $ from "jquery";
export default {
  name: "bookingComp",
  components: { sidebar_user },
  data() {
    return {
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      datas: [],
      inputsearch: "",
      addToCart_disable: false,
      readMore: {},
      item_data: {},
      items: [],
      showCart: false,
      verified: false,
      qty_booking: 1,
      cart: [],
      filteredArr: [],
      disable: {},
      loggedIn: false,
      isLoading: false,
      orders: [],
      show: false,
      staff: false,
      code: "",
      auth: [],
      chk_qty: [],
      qty_borrow_max_chk: 0,
      length_booking: 0,
      user: false,
      ckhaviable: false,
      checkItems: 0,
    };
  },
  mounted() {
    if (localStorage.getItem("auth") != null) {
      this.getorders();
      this.user = false;
      this.auth = JSON.parse(localStorage.getItem("auth"));
      this.code = this.auth.std_code;
      // console.log(this.code);
      if (localStorage.getItem("maxchk") == null) {
        this.qty_borrow_max_chk = this.auth.qty_borrow_max;
        localStorage.setItem("maxchk", this.auth.qty_borrow_max);
      }
      if (this.auth.isLibraryStaff === 1) {
        this.staff = true;
      } else {
        this.staff = false;
      }

      if (localStorage.getItem("orders") != null) {
        this.loadOrder();
      }
    } else {
      this.user = true;
    }
    this.datas = JSON.parse(localStorage.getItem("datas"));
    // console.log(this.datas.length ,"dtat check");

    if (this.datas.length !== 0) {
      // console.log("datas");
      // this.datas = JSON.parse(localStorage.getItem("datas"));
      this.show = true;
      // console.log(this.datas[0].qty_available);
      // if(this.datas[0].qty_available !== 0){
      //   this.ckhaviable = true
      // }else{
      //   this.ckhaviable = false
      // }
      for (var i in this.items) {
        for (var j in this.datas) {
          if (this.items[i].b4web_id == this.datas[j].b4web_id) {
            if (this.items[i].qty_booking == this.datas[j].qty_available) {
              this.status = true;
              this.$set(this.disable, this.datas[j].b4web_id, true);
            }
          } else {
            this.$set(this.disable, this.datas[j].b4web_id, false);
          }
        }
      }
    } else {
      this.Dosearch();
    }

    if (localStorage.getItem("booking") != null) {
      this.loadBooking();
      this.chkMaxBorrow();
    }

    if (localStorage.getItem("maxchk") != null) {
      this.qty_borrow_max_chk = localStorage.getItem("maxchk");
    }

    // this.status();
    // add to Cart
    $(document).ready(function () {
      $(".addtocart_").on("click", function () {
        var button = $(this);
        var cart = $("#cart");
        // var cartTotal = cart.attr("data-totalitems");
        // var newCartTotal = parseInt(cartTotal) + 1;

        button.addClass("sendtocart");
        setTimeout(function () {
          button.removeClass("sendtocart");
          cart.addClass("shake").attr("data-totalitems", this.items);
          setTimeout(function () {
            cart.removeClass("shake");
          }, 500);
        }, 1000);
      });
    });
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
  },
  methods: {
    Login() {
      this.$router.push("/login");
    },
    getorders() {
      let c = JSON.parse(localStorage.getItem("auth"));
      let data = {
        token: this.token,
        std_code: c.std_code,
      };
      const headers = {
        "content-type": "application/json",
      };

      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/getorder", data, {
          headers,
        })
        .then((res) => {
          if (res.data.msg.status != 200) {
            alert(res.data.msg.message);
          } else {
            if (res.data.Orders !== null) {
              this.orders = res.data.Orders;
              for (var i in this.orders) {
                if (this.orders[i].order_status === 5) {
                  this.orders.splice(this.orders.indexOf(this.orders[i]), 1);
                }
              }

              localStorage.setItem("orders", JSON.stringify(this.orders));
              this.show = true;
            }
          }
        });
    },

    loadOrder() {
      this.orders = JSON.parse(localStorage.getItem("orders"));
    },
    loadBooking() {
      this.items = JSON.parse(localStorage.getItem("booking"));
    },
    addToCart(item, b4web_id) {
      this.length_booking = JSON.parse(localStorage.getItem("chkqty"));
      if (localStorage.getItem("auth") != null) {
        if (this.qty_borrow_max_chk != this.length_booking) {
          this.length_booking += 1;
          item.qty_booking += 1;
          this.items.push(item);
          const seen = new Set();
          this.items = this.items.filter((el) => {
            const duplicate = seen.has(el.b4web_id);
            seen.add(el.b4web_id);
            return !duplicate;
          });
          for (var i in this.datas) {
            if (this.datas[i].b4web_id == b4web_id) {
              for (var j in this.items) {
                if (this.datas[i].qty_available == this.items[j].qty_booking) {
                  this.$set(this.disable, this.datas[j].b4web_id, true);
                } else {
                  this.$set(this.disable, this.datas[j].b4web_id, false);
                }
              }
            }
          }

          localStorage.setItem("booking", JSON.stringify(this.items));
          localStorage.setItem("chkqty", this.length_booking);
        } else if (this.qty_borrow_max_chk == this.length_booking) {
          alert(
            "ไม่สามารถจองรายการได้ เนื่องจากท่านใช้สิทธิครบแล้ว(" +
              this.qty_borrow_max_chk +
              "/" +
              this.length_booking +
              ") กรุณาคืนหนังสือ"
          );
        } else {
          console.log("!!ERROR");
        }
      } else {
        item.qty_booking += 1;
        this.items.push(item);

        this.chk_qty.push(item);

        const seen = new Set();
        this.items = this.items.filter((el) => {
          const duplicate = seen.has(el.b4web_id);
          seen.add(el.b4web_id);
          return !duplicate;
        });
        for (var ii in this.datas) {
          if (this.datas[ii].b4web_id == b4web_id) {
            for (var jj in this.items) {
              if (this.datas[ii].qty_available == this.items[jj].qty_booking) {
                this.$set(this.disable, this.datas[ii].b4web_id, true);
              } else {
                this.$set(this.disable, this.datas[ii].b4web_id, false);
              }
            }
          }
        }
        localStorage.setItem("booking", JSON.stringify(this.items));
        localStorage.setItem("chkqty", JSON.stringify(this.chk_qty));
      }
    },
    showBtn(b4web_id) {
      this.$set(this.disable, b4web_id, true);
    },
    disableBtn(b4web_id) {
      this.$set(this.disable, b4web_id, false);
    },
    showMore(id) {
      this.$set(this.readMore, id, true);
      // if(id){
      //   this.readMore= true;
      // }
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
    Dosearch() {
      if (this.inputsearch === null || this.inputsearch === "") {
        let data = {
          token: this.token,
          keyword: "",
        };
        const headers = {
          "content-type": "application/json",
        };
        this.$isLoading(true);
        axios
          .post("https://smartlibrary.ubru.ac.th/api/booking/search", data, {
            headers,
          })
          .then((res) => {
            // console.log(res);
            this.$isLoading(false); // hide loading screen
            if (res.data.msg.status != 200) {
              alert(res.data.msg.message);
            } else {
              this.datas = res.data.books;

              localStorage.setItem("datas", JSON.stringify(this.datas));
              this.show = true;
              for (var i in this.items) {
                for (var j in this.datas) {
                  if (this.items[i].b4web_id == this.datas[j].b4web_id) {
                    if (
                      this.items[i].qty_booking == this.datas[j].qty_available
                    ) {
                      this.$set(this.disable, this.datas[j].b4web_id, true);
                    }
                  } else {
                    this.$set(this.disable, this.datas[j].b4web_id, false);
                  }
                }
              }
            }
          });
      } else {
        let data = {
          token: this.token,
          keyword: this.inputsearch,
        };
        const headers = {
          "content-type": "application/json",
        };
        this.$isLoading(true);
        axios
          .post("https://smartlibrary.ubru.ac.th/api/booking/search", data, {
            headers,
          })
          .then((res) => {
            if (res.data.msg.status != 200) {
              this.$isLoading(false);
              alert(res.data.msg.message);
            } else {
              this.$isLoading(false);
              this.datas = res.data.books;
              localStorage.setItem("datas", JSON.stringify(this.datas));
              this.show = true;
              // console.log(this.datas[0].qty_available);
              // if(this.datas[0].qty_available !== 0){
              //   this.ckhaviable = true
              // }else{
              //   this.ckhaviable = false
              // }
              for (var i in this.items) {
                for (var j in this.datas) {
                  if (this.items[i].b4web_id == this.datas[j].b4web_id) {
                    if (
                      this.items[i].qty_booking == this.datas[j].qty_available
                    ) {
                      this.status = true;
                      this.$set(this.disable, this.datas[j].b4web_id, true);
                    }
                  } else {
                    this.$set(this.disable, this.datas[j].b4web_id, false);
                  }
                }
              }
            }
          });
      }
    },
    // logout() {
    //   this.$store.dispatch("logout").then(() => {
    //     this.$router.push("/");
    //   });
    // },
    // status() {
    //   if (!localStorage.getItem("access_token")) {
    //     this.loggedIn = true;
    //   } else {
    //     this.loggedIn = false;
    //   }
    // },
    chkMaxBorrow() {
      for (var index in this.items) {
        this.length_booking += this.items[index].qty_booking;
      }
      localStorage.setItem("chkqty", this.length_booking);
    },
    removeFromCart(item) {
      if (this.items.length === 0) {
        this.length_booking = 0;
        localStorage.setItem("chkqty", this.length_booking);
      } else {
        this.length_booking = localStorage.getItem("chkqty");

        this.length_booking -= item.qty_booking;
        localStorage.setItem("chkqty", this.length_booking);
      }

      item.qty_booking = 0; //fillter
      this.items.splice(this.items.indexOf(item), 1);
      localStorage.setItem("booking", JSON.stringify(this.items));
    },
    sendItem(items) {
      // console.log(items,'add item');
      let IP = localStorage.getItem("IP");

      let data = {
        token: this.token,
        books: items,
        std_code: this.code,
        staff_code: "",
        public_ip: IP,
      };

      const headers = {
        "content-type": "application/json",
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/datas", data, {
          headers,
        })
        .then((res) => {
          if (res.data.msg.status != 200) {
            alert(res.data.msg.message);
          } else {
            let order = res.data.Orders;
            this.orders = res.data.Orders;
            if (order === null) {
              localStorage.setItem("orders", "null");
            } else {
              localStorage.setItem("orders", JSON.stringify(order));
            }
            this.booking = [];
            localStorage.setItem("booking", JSON.stringify(this.booking));
            localStorage.setItem("chkqty", JSON.stringify(this.chkqty));
            this.$isLoading(false);
            this.$router.push("checkOrder");
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css");
.main {
  width: 50%;
  margin: 50px auto;
}
img {
  height: 260px;
}
.card-service {
  background-color: var(--greyLight-1);

  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
  background: none;
  font-family: inherit;
}
.home-section {
  position: relative;
  background: var(--greyLight-1);
  min-height: 100vh;
  top: 0;
  left: 78px;
  width: calc(100% - 78px);
  transition: all 0.5s ease;
  z-index: 2;
}
.sidebar.open ~ .home-section {
  left: 250px;
  width: calc(100% - 250px);
}
.home-section .text {
  display: inline-block;
  color: #11101d;
  font-size: 25px;
  font-weight: 500;
  margin: 18px;
}

/*SEARCH */

.search {
  grid-column: 3/4;
  grid-row: 2/3;
  position: relative;
  display: flex;
  align-items: center;
}
.search__input {
  width: 100%;
  height: 3rem;
  border: none;
  border-radius: 1rem;
  font-size: 1.4rem;
  padding-left: 3.8rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  background: none;
  font-family: inherit;
  /*color: var(--greyDark);*/
}
.search__input::-moz-placeholder {
  color: var(--greyLight-3);
}
.search__input:-ms-input-placeholder {
  color: var(--greyLight-3);
}
.search__input::placeholder {
  color: var(--greyLight-3);
}
.search__input:focus {
  outline: none;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
}
.search__input:focus + .search__icon {
  color: orangered;
}
.search__icon {
  height: 1.3rem;
  position: absolute;
  font-size: 1.5rem;
  padding: 0 1.5rem;
  display: flex;
  color: var(--greyDark);
  transition: 0.3s ease;
}
.card-body-menu {
  margin-top: 70px;
  font-family: "Kanit", sans-serif;
}
.card-title {
  text-align: center;
  font-family: "Kanit", sans-serif;
}
::placeholder {
  color: rgb(255, 255, 255);
}
.card-search {
  top: 20px;
  border: 0px solid;
  font-family: "Kanit", sans-serif;
}
/* END SEARCH*/

/*  CHIP  */
.chip {
  grid-column: 2 / 3;
  grid-row: 3 / 4;
  justify-self: center;
  width: 20rem;
  height: 4rem;
  border-radius: 1rem;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__icon {
    width: 3rem;
    height: 3rem;
    border-radius: 1rem;
    margin: 0 0 0 0.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.8rem;
    color: var(--primary);
  }

  p {
    font-size: 1.1rem;
    margin-left: -1rem;
    color: #000;
    margin-top: 18px;
  }

  &__close {
    width: 1.6rem;
    height: 1.6rem;
    margin: 0 0.5rem;
    display: flex;
    font-size: 1.6rem;
    color: var(--greyLight-3);
    cursor: pointer;
  }
}
/**/
/*card*/

.card-title {
  text-align: left;
  /* text-align: justify; */
  bottom: 10px;
  font-family: "Kanit", sans-serif;
  font-weight: bold;
}
.card-text {
  text-align: left;
  line-height: 23px;
  /* bottom: 5px; */
  font-family: "Kanit", sans-serif;
  font-weight: bold;
}

.icon-booking {
  padding: 5px;
}
.side-left {
  position: fixed;
  width: 256px;
}
.txt-sidebar {
  text-align: left;
}
.zoom {
  padding: 25px;
  /* background-color: green; */
  transition: transform 0.2s;
  /* width: 200px;
  height: 200px; */
  margin: 0 auto;
}

.zoom:hover {
  -ms-transform: scale(1.5); /* IE 9 */
  -webkit-transform: scale(1.5); /* Safari 3-8 */
  transform: scale(1.5);
}

.btn-purple {
  color: #fff;
  border-color: rgb(255, 95, 45);
  background-color: rgb(255, 95, 45);
}

.btn-purple:hover {
  color: #fff;
  border-color: rgb(250, 129, 92);
  background-color: rgb(254, 110, 66);
}
.btn-purple:focus,
.btn-purple.focus {
  color: #fff;
  border-color: rgb(250, 129, 92);
  background-color: rgb(254, 110, 66);
  box-shadow: 0 0 0 0.2rem rgba(255, 109, 65, 0.468);
}
.btn-purple.disabled,
.btn-purple:disabled {
  color: #fff;
  border-color: rgb(255, 95, 45);
  background-color: rgb(255, 95, 45);
}
.btn-purple:not(:disabled):not(.disabled):active,
.btn-purple:not(:disabled):not(.disabled).active,
.show > .btn-purple.dropdown-toggle {
  color: #fff;
  border-color: rgb(255, 95, 45);
  background-color: rgb(250, 129, 92);
}
.btn-purple:not(:disabled):not(.disabled):active:focus,
.btn-purple:not(:disabled):not(.disabled).active:focus,
.show > .btn-purple.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 109, 65, 0.468);
}
/*  */

.btn-outline-purple {
  color: rgb(255, 95, 45);
  border-color: rgb(255, 95, 45);
}

.btn-outline-purple:hover {
  color: #fff;
  background-color: rgb(255, 95, 45);
  border-color: rgb(255, 95, 45);
}

.btn-outline-purple:focus,
.btn-outline-purple.focus {
  box-shadow: 0 0 0 0.2rem rgb(250, 129, 92);
}

.btn-outline-purple.disabled,
.btn-outline-purple:disabled {
  color: rgb(255, 95, 45);
  background-color: transparent;
}

.btn-outline-purple:not(:disabled):not(.disabled):active,
.btn-outline-purple:not(:disabled):not(.disabled).active,
.show > .btn-outline-purple.dropdown-toggle {
  color: #fff;
  background-color: rgb(255, 95, 45);
  border-color: rgb(255, 95, 45);
}

.btn-outline-purple:not(:disabled):not(.disabled):active:focus,
.btn-outline-purple:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-purple.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgb(250, 129, 92);
}

@media screen and (max-width: 576px) {
  img {
    height: 360px;
  }
}

@media screen and (max-width: 767px) {
  img {
    height: 300px;
  }
}

/*cart*/

/*
.page-wrapper {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.page-wrapper button {
 
  position: absolute;
  bottom: 1px;
  right: 10px;
  width: 70px;
  bottom: 20px;
}
.page-wrapper button .cart-item {
  position: absolute;
  height: 24px;
  width: 24px;
  top: -10px;
  right: -10px;
  z-index: 999;
}
.page-wrapper button .cart-item:before {

  content: "\f02d";
  display: block;
  line-height: 24px;
  height: 24px;
  width: 24px;
  font-size: 12px;
  font-weight: 600;
  background: rgb(255, 95, 45);
  color: white;
  border-radius: 20px;
  text-align: center;
}
.page-wrapper button.sendtocart .cart-item {
  display: block;
  animation: xAxis 1s forwards cubic-bezier(1, 0.44, 0.84, 0.165);
}
.page-wrapper button.sendtocart .cart-item:before {
  animation: yAxis 1s alternate forwards cubic-bezier(0.165, 0.84, 0.44, 1);
}

*/
.modal-img {
  height: 90px;
}
.new-version {
  position: fixed;
  bottom: 20px;
  a {
    color: #2bd156;
    text-decoration: none;
  }
}

.page-wrapper {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  button {
    position: absolute;
    bottom: 1px;
    right: 10px;
    width: 70px;
    bottom: 20px;
    /* padding: 20px;
    border: none;
    background: lighten(#292d48, 65);
    position: relative;
    outline: none;
    border-radius: 5px;
    color: #292d48;
    font-size: 18px;*/
    .cart-item {
      position: absolute;
      height: 24px;
      width: 24px;
      top: -10px;
      right: -10px;

      &:before {
        content: "\f02d";
        display: block;
        line-height: 24px;
        height: 24px;
        width: 24px;
        font-size: 13px;
        font-weight: bold;
        background: rgb(255, 255, 255);
        color: rgb(255, 130, 68);
        border-radius: 20px;
        text-align: center;
        font-family: FontAwesome;
      }
    }
    &.sendtocart {
      .cart-item {
        display: block;
        animation: xAxis 1s forwards cubic-bezier(1, 0.44, 0.84, 0.165);
        &:before {
          animation: yAxis 1s alternate forwards
            cubic-bezier(0.165, 0.84, 0.44, 1);
        }
      }
    }
  }
}

.cart {
  position: fixed;
  top: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  background: rgb(255, 95, 45);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  z-index: 999;
  border-radius: 50%;
  i {
    font-size: 25px;
    color: white;
  }
  &:before {
    content: attr(data-totalitems);
    font-size: 12px;
    font-weight: 600;
    position: absolute;
    top: -12px;
    right: 0px;
    background: rgb(0, 23, 153);
    line-height: 24px;
    padding: 0 5px;
    height: 24px;
    min-width: 24px;
    color: rgb(255, 255, 255);
    text-align: center;
    border-radius: 24px;
  }
  &.shake {
    animation: shakeCart 0.4s ease-in-out forwards;
  }
}

@keyframes xAxis {
  100% {
    transform: translateX(calc(50vw - 105px));
  }
}

@keyframes yAxis {
  100% {
    transform: translateY(calc(-50vh + 75px));
  }
}

@keyframes shakeCart {
  25% {
    transform: translateX(6px);
  }
  50% {
    transform: translateX(-4px);
  }
  75% {
    transform: translateX(2px);
  }
  100% {
    transform: translateX(0);
  }
}
</style>
